module.exports = __webpack_public_path__ + "static/media/cat-ram2.ec966d18.jpg";